<div class="modal-content mt-md-5">
    <div class="decision-content cc-content">
        <ngb-carousel #decisionWizard
            (touchstart)="onTouchStart($event)"
            (touchend)="onTouchEnd($event)">
            <ng-template *ngFor="let decision of decisions;" ngbSlide>
                 <div class="cc-top text-center">
                    <h1 class="cc-h1" *ngIf="firstPage">Motivation</h1>
                    <h2 class="cc-h2" *ngIf="firstPage">{{decision.question}}</h2>
                    <h1 class="cc-h1" *ngIf="finalPage">Your pick</h1>
                    <h2 class="cc-h2" *ngIf="finalPage">{{decisions[0]?.selectedOption?.title}}</h2>
                    <div class="cc-custom-separator"></div>
                    <div ngbDropdown 
                        *ngIf="finalPage"
                        #decisionDrop="ngbDropdown" 
                        class="dropdown-wrap mt-5" 
                        placement="top bottom">
                            <button ngbDropdownAnchor 
                                class="btn {{noError == true ? 'btn-primary' : 'btn-danger'}}" 
                                id="decisionOptions" 
                                (click)="decisionDrop.open()">{{decision?.selectedOption != undefined? decision?.selectedOption?.title : 'Select Level' }}</button>
                                
                                <div ngbDropdownMenu 
                                    arial-labelledby="decisionOptions"
                                    class="text-center">
                                    <ng-container *ngFor="let choice of decision.choices">
                                        <button class="dropdown-item" 
                                            *ngIf="choice.enable" 
                                            (click)="makeDecision(decision, 3, choice)">{{choice?.title}}</button>
                                    </ng-container>
                                </div>
                        </div>
                </div>
                
                <div class="decision-splash-wrapper mb-md-2 text-center">
                    <div class="center-splash">
                        <img class="decision-splash" src="assets/images/icons/{{decision.image || 'header.png'}}" alt="Decision image" loading="lazy">
                    </div>
                    <div class="text-center">
                        <p class="mb-1">Lets learn your interests & profile.
                            <span class="cc-tooltip mx-1" 
                                *ngIf="decision.description != ''" 
                                ngbTooltip="{{decision.description}}" [autoClose]="true"
                                triggers="click" >&nbsp;</span>
                        </p>
                        <!-- The dropdown selection -->
                        <!-- <div ngbDropdown 
                            #decisionDrop="ngbDropdown" 
                            class="dropdown-wrap mb-5" 
                            placement="top bottom">
                                
                            <button ngbDropdownAnchor 
                                class="btn {{noError == true ? 'btn-primary' : 'btn-danger'}}" 
                                id="decisionOptions" 
                                (click)="decisionDrop.open()">{{decision.selectedOption != undefined? decision.selectedOption.title : 'Select Option' }}</button>
                                
                                <div ngbDropdownMenu 
                                    arial-labelledby="decisionOptions"
                                    class="text-center">
                                    
                                        <ng-container *ngFor="let choice of decision.choices">
                                            <button class="dropdown-item" 
                                                *ngIf="choice.enable" 
                                                (click)="makeDecision(decision, choice)">{{choice.title}}</button>
                                        </ng-container>
                                </div>
                        </div> -->
                    </div>
                </div>
            </ng-template>
        </ngb-carousel>
        <div class="row cc-lower my-4 my-md-6">
            <button class="col mr-3 cc-button-primary" 
                *ngIf="firstPage == true"  
                (click)="idkHelp()">Feeling Lucky</button>
            
            <button class="col me-3 me-md-5 cc-button-secondary" 
                *ngIf="firstPage != true"    
                (click)="previous()">Back</button>    
            
            <button class="col ml-3 cc-button-primary" *ngIf="finalPage == true"
                (click)="complete()">Start</button>
    
            <button class="col ms-3 ms-md-5 cc-button-primary" 
                *ngIf="finalPage != true"
                 ngbTooltip="Coming soon, thanks for your interest!" 
                 [autoClose]="true"
                 disabled 
                (click)="next()">Recommend</button>
        </div>
    </div>
</div>